import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsRemovedIssuesRoute: InvariantJiraRoute = {
	name: 'plan-settings-removed-issues',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues',
};
